import './css/index.css';

document.addEventListener( 'DOMContentLoaded', function () {

    const expandAllBtns = document.querySelectorAll( '.expand-all-btn' );

    expandAllBtns.forEach( ( expandAllBtn ) => {

        expandAllBtn.addEventListener( 'click', function () {

            const parent = expandAllBtn.parentElement;

            const accordions = parent.querySelectorAll( '.text-block-full-width-accordion-tab input' );

            if ( expandAllBtn.innerHTML === 'Expand All' ) {

                expandAllBtn.innerHTML = 'Collapse All';

                accordions.forEach( ( checkbox ) => {

                    checkbox.checked = true;

                } );

            }
            else {

                expandAllBtn.innerHTML = 'Expand All';

                accordions.forEach( ( checkbox ) => {

                    checkbox.checked = false;

                } );

            }

        } );

    } );

    const allAccordions = document.querySelectorAll( '.text-block-full-width-accordion-tab' );

    allAccordions.forEach( ( accordion ) => {

        accordion.addEventListener( 'click', function () {

            const parent = accordion.parentElement;

            const accordionsChecked = parent.querySelectorAll( '.text-block-full-width-accordion-tab input:checked' );
            const accordionsTotal = parent.querySelectorAll( '.text-block-full-width-accordion-tab input' );

            const expandAllBtn = parent.querySelectorAll( '.expand-all-btn' )[ 0 ];

            if ( accordionsChecked.length === accordionsTotal.length ) {

                expandAllBtn.innerHTML = 'Collapse All';

            }
            else if ( accordionsChecked.length === 0 ) {

                expandAllBtn.innerHTML = 'Expand All';

            }

        } );

    } );

} );
